import type {ContextProvider, ContextProviderDataGeneric} from '@bitstillery/common/lib/context'
import {MithrilComponent} from '@bitstillery/mithril'
import {
    CollectionBulkControl,
    CollectionColumns,
    CollectionFilterControl,
    CollectionSorter,
    CollectionStatus,
} from '@bitstillery/common/components'
import {$s} from '@bitstillery/common/app'
import m from '@bitstillery/mithril'

import type {CollectionColumnSetup, CollectionProxy} from '@bitstillery/common/lib/collection'

interface CollectionHeaderAttrs {
    collection?: CollectionProxy
    /** Used for bulk mode to access the context */
    context?: ContextProvider<ContextProviderDataGeneric> | undefined
    columns?: CollectionColumnSetup<never>
}
export class CollectionHeader extends MithrilComponent<CollectionHeaderAttrs> {
    view(vnode: m.Vnode<CollectionHeaderAttrs>) {
        return (
            <div className='c-collection-header'>
                {Array.isArray(vnode.children) && vnode.children.length > 0
                    ? vnode.children
                    : [
                          <div className='actions'>
                              {vnode.attrs.collection?.bulk && (
                                  <CollectionBulkControl
                                      action='edit'
                                      collection={vnode.attrs.collection}
                                      context={vnode.attrs.context}
                                  />
                              )}
                              {$s.env.layout === 'desktop' &&
                                  vnode.attrs.collection &&
                                  Object.values(vnode.attrs.collection.filters).length > 0 && (
                                      <CollectionFilterControl collection={vnode.attrs.collection} />
                                  )}

                              {vnode.attrs.collection && <CollectionSorter collection={vnode.attrs.collection} />}
                              {vnode.attrs.collection && <CollectionStatus collection={vnode.attrs.collection} />}
                          </div>,
                          vnode.attrs.collection && vnode.attrs.columns && (
                              <CollectionColumns collection={vnode.attrs.collection} columns={vnode.attrs.columns} />
                          ),
                      ]}
            </div>
        )
    }
}
